import styled from 'styled-components';

export const Container = styled.div``;

export const Content = styled.div`
  background-color: #cce6ee;
  padding: 17px 15px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  width: 397px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 20px;

  > p {
    color: #0384ac;
    font-size: 18px;
    margin: 10px 20px 5px;
  }

  > span {
    color: #0384ac80;
    font-size: 14px;
  }
`;

export const Section = styled.p`
  color: #0384ac;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 15px;
`;

export const Line = styled.div`
  height: 1px;
  width: 100%;
  background-color: #0384ac80;
  margin-top: 5px;
  margin-bottom: 10px;
`;

export const Text = styled.span`
  color: #0384ac;
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  font-size: 14px;
  margin-bottom: 10px;
`;
